import { Dispatch, SetStateAction } from 'react'
import styles from './Inputs.module.css'
import { DefaultNumberInput } from '../../../Inputs/DefaultNumberInput/DefaultNumberInput'

interface InternalCreditAmountProps {
  amount: number | null
  setAmount: Dispatch<SetStateAction<number | null>>
}

export const InternalCreditAmount = ({
  amount,
  setAmount,
}: InternalCreditAmountProps) => {
  const internalCreditAmount = () => (
    <div className={styles.inputContainer}>
      <label className={styles.inputLabel}>Belopp</label>

      <DefaultNumberInput
        value={amount}
        onChange={setAmount}
        min={0}
        width={90}
      />
    </div>
  )

  return internalCreditAmount()
}
